import { t } from '@gem/modules/i18n';

import Entities from 'STORE';

interface ICheckP2PVoicePermission {
  result: boolean;
  error?: string;
}

export function checkP2PVoicePermission(groupId: string): ICheckP2PVoicePermission {
  const group = Entities.GroupsStore.getGroupById(groupId);
  if (!group) {
    return { result: false };
  }

  if (group.isP2P && !group.groupOpponent?.privacyStatus?.sendVoiceMessage) {
    return {
      result: false,
      error: t('common_privacy_voice_message_alert').replace(
        '{0}',
        group.groupOpponent?.displayName || ''
      ),
    };
  }

  return { result: true };
}
